export enum PageMode {
  Password = 1,
  Picture = 2,
  QrCode = 3
}

export interface ILoginPageQueryparameters {
  LoginHint?: string;
  PageMode?: PageMode;
}

export function toSnakeCase(obj: object): Record<string, unknown> {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    const snakeCaseKey = key.replace(/([A-Z])/g, "_$1").toLowerCase().replace(/^_/, "");
    acc[snakeCaseKey] = value;
    return acc;
  }, {} as Record<string, unknown>);
}